// Environment de desarrollo
export const environment = {
  production: false,
  apiUrl: 'https://api.radar.sdi.es/api',
  authUrl: 'https://api.radar.sdi.es',
};
